import {
	EverplansEmailStatusEnum,
	type SubmissionAction,
} from '@/classes/SubmissionStatuses/types'
import FixEmailModalContent from '@/components/home/SubmissionStatuses/ResubmissionModals/FixEmailModalContent.vue'

export default class FixEmailAction implements SubmissionAction {
	buttonText = 'Fix'
	component = FixEmailModalContent
	componentProps: Record<string, unknown>

	constructor(
		emailErrorStatus: EverplansEmailStatusEnum,
		lastSubmittedEmail?: string | null
	) {
		this.componentProps = { emailErrorStatus, lastSubmittedEmail }
	}
}
